import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const POPUP_TYPE = {
    SYS_INFO: 0,
    SYS_ERROR: 1,
    INPUT_ERROR: 2,
}

export const PopupMessage = (props) => {
    if (props.type === POPUP_TYPE.SYS_INFO) {
        return (
            <Wrap>
                <Title>
                    <i className="fas fa-info-circle" />
                    システムメッセージ
                </Title>
                <Message>
                    {props.message}
                </Message>
            </Wrap>
        );
    } else if (props.type === POPUP_TYPE.SYS_ERROR) {
        return (
            <Wrap>
                <Title>
                    <i className="fas fa-exclamation-triangle" />
                    システムエラー
                </Title>
                <Message>
                    {props.message}
                </Message>
            </Wrap>
        );
    } else if (props.type === POPUP_TYPE.INPUT_ERROR) {
        return (
            <Wrap>
                <Title>
                    <i className="fas fa-exclamation-triangle" />
                    入力エラー
                </Title>
                <Message>
                    {props.message}
                </Message>
            </Wrap>
        );
    }
}

PopupMessage.propTypes = {
    message: PropTypes.object.isRequired,
};

const Wrap = styled.div`
    padding: 0px 20px 0px 10px;
`;
const Title = styled.div`
    margin-bottom: 2px;
    i { 
        margin-right: 5px;
    }
`;
const Message = styled.div`
    margin-left: 20px;
`;
